import appConfig from '../../config/app';
import { getAuthHeaders } from './auth';

const request = async (path, options = {}) => {
  const response = await fetch(`${appConfig.baseApiUrl}${path}`, {
    ...options,
    headers: {
      ...(await getAuthHeaders()),
      ...(options.headers || {}),
    },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || body.errors?.join(', ') || 'Unable to load private lessons');
  }

  return response.status === 204 ? null : response.json();
};

export const fetchPrivateLessonCoaches = (gymUid) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_coaches`);

export const fetchPrivateLessonSlots = (gymUid, { coachUid, startDate, endDate } = {}) => {
  const params = new URLSearchParams();
  if (coachUid) params.set('coach_uid', coachUid);
  if (startDate) params.set('start_date', startDate);
  if (endDate) params.set('end_date', endDate);
  const query = params.toString();
  return request(`/api/v1/gyms/${gymUid}/private_lesson_slots${query ? `?${query}` : ''}`);
};

export const fetchPrivateLessonBookings = (gymUid, scope) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_bookings${scope ? `?scope=${scope}` : ''}`);

export const createPrivateLessonSlot = (gymUid, slot) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_slots`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ private_lesson_slot: slot }),
  });

export const createBulkPrivateLessonSlots = (gymUid, schedule) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_slots/bulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ private_lesson_bulk: schedule }),
  });

export const deletePrivateLessonSlot = (gymUid, slotId) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_slots/${slotId}`, { method: 'DELETE' });

export const createPrivateLessonBooking = (gymUid, slotId, booking) =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_slots/${slotId}/bookings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ private_lesson_booking: booking }),
  });

export const cancelPrivateLessonBooking = (gymUid, bookingId, cancellationReason = '') =>
  request(`/api/v1/gyms/${gymUid}/private_lesson_bookings/${bookingId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      private_lesson_booking: { status: 'cancelled', cancellation_reason: cancellationReason },
    }),
  });
